import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  private minutes = 3;
  private apiUrl = `${environment}`;
  constructor(private readonly httpClient: HttpClient) {}

  public refreshAccessToken(): Observable<any> {
    const refreshToken = this.getRefreshToken();
    return this.httpClient.get<any>(`${this.apiUrl}/RefreshToken/${refreshToken}`);
  }

  public removeUserAccess() {
    localStorage.removeItem('USER_SESSION');
  }

  public getAccessTokenValidTo() {
    return this.getTokens()?.accessTokenValidTo ?? null;
  }
  public getRefreshToken() {
    return this.getTokens()?.refreshToken ?? '';
  }
  public getAccessToken() {
    return this.getTokens()?.accessToken ?? '';
  }
  private getUserSession() {
    return JSON.parse('') ?? null;
  }
  private getTokens() {
    return this.getUserSession()?.tokens ?? null;
  }

  public isAccessTokenExpiringSoon(): boolean {
    const expirationTime = this.getDateTimeFromString(this.getAccessTokenValidTo()) ?? null;
    if (!expirationTime) return false;
    const currentTime = this.getDateTimeFromString(new Date(Date.now()).toISOString());
    const timeDifference = expirationTime - (currentTime ?? 0);
    const expiringSoon = this.minutes * 60 * 1000;
    return timeDifference < expiringSoon;
  }

  public storeTokens(tokens: any) {
    const userSession = this.getUserSession();
    userSession.tokens.accessToken = tokens.accessToken;
    userSession.tokens.idToken = tokens.idToken;
    userSession.tokens.accessTokenValidTo = tokens.accessTokenValidTo;
    localStorage.setItem('USER_SESSION', JSON.stringify(userSession));
  }

  private getDateTimeFromString(dateString: string) {
    if (!dateString) return null;
    const dateObject = new Date(dateString);
    return dateObject.getTime() ?? null;
  }
}
